import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetRemove82FullCaption() {
    return (<FullCaptionComponent title="VALUE: 82">
        <HashSetRemove821/>
        <HashSetRemove822/>
        <HashSetRemove823/>
        <HashSetRemove824/>
    </FullCaptionComponent>)
}

export function HashSetRemove821() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>1. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Assuming our hash function is <CodeComponent>{generateHashFunction}</CodeComponent>, if we input 82, we
            output a <CodeComponent className="codeHash">HASH</CodeComponent> of 2.</p>
    </CaptionStepComponent>)
}

export function HashSetRemove822() {
    return (<CaptionStepComponent title={<h6>2. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 2, we now want to find the
            sub-collection at index 2 of our array.</p>
    </CaptionStepComponent>)
}

export function HashSetRemove823() {
    return (<CaptionStepComponent title={<h6>3. Iterate over our sub-collection until we found the <CodeComponent
        className="codeValue">VALUE</CodeComponent> we want to remove. <CodeComponent>O(n)</CodeComponent></h6>}>
        <p>At <CodeComponent className="codeHash">HASH</CodeComponent> index 2, we see we have multiple items due to
            collisions when inserting the <CodeComponent className="codeValue">VALUES</CodeComponent> into our HashSet.
            We see here we have a worst case scenario, so our time complexity is <CodeComponent>O(n)</CodeComponent> as
            we must iterate over the entire sub-collection until we found the <CodeComponent
                className="codeValue">VALUE</CodeComponent> we want to remove. In this case, we can see
            the <CodeComponent className="codeValue">VALUE</CodeComponent> we want to remove is the very last element in
            our sub-collection. So we must iterate over every single <CodeComponent
                className="codeValue">VALUE</CodeComponent> in order to find it.</p>
    </CaptionStepComponent>)
}

export function HashSetRemove824() {
    return (<CaptionStepComponent
        title={<h6>4. Remove <CodeComponent className="codeValue">VALUE</CodeComponent> from our
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>We remove our <CodeComponent className="codeValue">VALUE</CodeComponent> of 82 from the sub-collection.</p>
    </CaptionStepComponent>)
}
